module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_iterators.js
 ** module id = 1252
 ** module chunks = 1
 **/